// 이미지 소스 타입
export const IMAGE_SOURCES = {
  NAVER: 'NAVER',
  // 다른 이미지 소스들이 있다면 추가
};

// 성별 타입
export const GENDERS = {
  MALE: '남자',
  FEMALE: '여자',
  // 다른 성별 타입이 있다면 추가
};

// 컬럼 정의
export const COLUMNS = [
  { id: 'id', label: 'ID', type: 'number', width: 70 },
  { id: 'image_url', label: '이미지', type: 'image', width: 120 },
  { id: 'image_source', label: '이미지 소스', type: 'select', options: Object.values(IMAGE_SOURCES), width: 120 },
  { id: 'width', label: '너비', type: 'number', width: 80 },
  { id: 'height', label: '높이', type: 'number', width: 80 },
  { id: 'usable', label: '사용 가능', type: 'boolean', width: 100 },
  { id: 'caption', label: '캡션', type: 'text', width: 200 },
  { id: 'gender', label: '성별', type: 'select', options: Object.values(GENDERS), width: 80 },
  { id: 'salon_id', label: '미용실', type: 'select', options: [], width: 120 },
  { id: 'designer_id', label: '디자이너', type: 'select', options: [], width: 120 },
  { id: 'hair_style_id', label: '헤어 스타일', type: 'select', options: [], width: 120 },
  { id: 'hair_length_id', label: '헤어 길이', type: 'select', options: [], width: 120 },
  { id: 'bangs_id', label: '앞머리', type: 'select', options: [], width: 100 },
  { id: 'hair_color_id', label: '헤어 색상', type: 'select', options: [], width: 120 },
  { id: 'lora_model_id_list', label: 'LoRA 모델', type: 'text', width: 150 },
];

// 필터 타입
export const FILTER_TYPES = {
  image_source_list: '이미지 소스',
  salon_id_list: '살롱',
  designer_id_list: '디자이너',
  gender_list: '성별',
  hair_style_id_list: '헤어 스타일',
  hair_length_id_list: '헤어 길이',
  bangs_id_list: '앞머리',
  hair_color_id_list: '헤어 색상',
  usable_list: '사용 가능',
  lora_model_id_list: 'LoRA 모델',
};

// 키보드 단축키 정의
export const KEYBOARD_SHORTCUTS = {
  MOVE_LEFT: 'h',
  MOVE_DOWN: 'j',
  MOVE_UP: 'k',
  MOVE_RIGHT: 'l',
  SELECT_RECORD: 'v',
  OPEN_CELL: ' ', // 스페이스바
  CLOSE_DROPDOWN: 'Escape',
}; 